"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.History = void 0;
exports.addHistoryListener = addHistoryListener;
exports.compileURL = compileURL;
exports.removeHistoryListener = removeHistoryListener;
exports.resolveURL = resolveURL;
exports.testURL = testURL;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/ends-with"));
var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _trim2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/assign"));
var _map3 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));
var _filter2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));
var _unnest2 = _interopRequireDefault(require("lodash/fp/unnest"));
var _split2 = _interopRequireDefault(require("lodash/fp/split"));
var _map4 = _interopRequireDefault(require("lodash/fp/map"));
var _join2 = _interopRequireDefault(require("lodash/fp/join"));
var _filter3 = _interopRequireDefault(require("lodash/fp/filter"));
var _compose2 = _interopRequireDefault(require("lodash/fp/compose"));
var _add2 = _interopRequireDefault(require("lodash/fp/add"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _trimStart2 = _interopRequireDefault(require("lodash/trimStart"));
var _trim3 = _interopRequireDefault(require("lodash/trim"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _flowRight2 = _interopRequireDefault(require("lodash/flowRight"));
var _flattenDeep2 = _interopRequireDefault(require("lodash/flattenDeep"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));
var _query = require("../query");
var _privateContext = require("../../private-context");
var _state = require("./state");
(0, _state.initializeHistoryState)();
const _ = (0, _privateContext.createPrivateContext)();
function testVal(test, val) {
  return test instanceof RegExp && test.test(val) || test === val;
}
function testURL(pathname, query = {}, test = window.location.pathname, search = window.location.search) {
  var _context, _context2;
  let i = 0;
  pathname = pathname.replace(/\/?\*{2}/g, () => `:${i++}(/.+)?`);
  const keys = [];
  const match = (0, _pathToRegexp.default)(pathname, keys, {
    sensitive: true
  }).exec(test);
  if (!(0, _isArray.default)(match)) {
    return;
  }
  const params = (0, _reduce.default)(keys).call(keys, (obj, {
    name
  }, index) => {
    let val = (0, _trim3.default)(match[index + 1], '/');
    if (typeof obj[name] !== 'undefined') {
      val = [...((0, _isArray.default)(obj[name]) ? obj[name] : [obj[name]]), val];
    }
    return {
      ...obj,
      [name]: val
    };
  }, {});
  query = typeof query === 'string' ? (0, _query.queryStringToObject)(query) : query;
  const currentQuery = (0, _query.queryStringToObject)(search);
  const queryMatch = (0, _map2.default)(_context = (0, _reduce.default)(_context2 = (0, _keys.default)(query || {})).call(_context2, (arr, key) => [...arr, {
    key,
    test: query[key],
    val: currentQuery[(0, _trim3.default)(key, '!?')]
  }], [])
  // eslint-disable-next-line no-shadow
  ).call(_context, ({
    key,
    test,
    val
  }) => {
    if ((0, _endsWith.default)(key).call(key, '?')) {
      return (0, _isUndefined2.default)(val) || test === '*' || testVal(test, val);
    }
    if ((0, _startsWith.default)(key).call(key, '!')) {
      if (test === '*') {
        return (0, _isUndefined2.default)(val);
      }
      return !val;
    }
    if (test === '*') {
      return !(0, _isUndefined2.default)(val);
    }
    return testVal(test, val);
  });
  if ((0, _includes.default)(queryMatch).call(queryMatch, false)) {
    return;
  }
  return {
    params,
    query: currentQuery
  };
}
function compileURL(pathname, params = {}, query = {}, hash = '') {
  let i = 0;
  pathname = pathname.replace(/\/?\*{2}/g, () => `/:${i++}*`);
  if ((0, _isString2.default)(params)) {
    params = [(0, _trim3.default)(params, '/').split(/\/+/g)];
  }
  if ((0, _isArray.default)(params)) {
    params = {
      ...params
    };
  }
  if ((0, _isPlainObject2.default)(params)) {
    var _context3;
    (0, _forEach.default)(_context3 = (0, _keys.default)(params)).call(_context3, key => {
      let val = params[key];
      if (!isNaN(key)) {
        if ((0, _isString2.default)(val)) {
          val = (0, _trim3.default)(val, '/').split(/\/+/g);
        }
        if ((0, _isArray.default)(val)) {
          if (val.length > 0) {
            params[key] = val;
          } else {
            delete params[key];
          }
        }
      }
    });
  }
  pathname = _pathToRegexp.default.compile(pathname)(params || {});
  if (!(0, _isString2.default)(query)) {
    query = (0, _query.toQueryString)(query || {});
  }
  query = (0, _trimStart2.default)((0, _trim2.default)(query).call(query), '?');
  if (query) {
    query = '?' + query;
  }
  if (!(0, _isString2.default)(hash)) {
    hash = (0, _query.toQueryString)(hash || {});
  }
  hash = (0, _trimStart2.default)((0, _trim2.default)(hash).call(hash), '#');
  if (hash) {
    hash = '#' + hash;
  }
  return pathname + query + hash;
}
function resolveURL(...args) {
  const isNotEmpty = arg => !!arg;
  const preferAbsolute = preferAbsoluteArgs => (0, _reduce.default)(preferAbsoluteArgs).call(preferAbsoluteArgs, (memo, arg) => (0, _startsWith.default)(arg).call(arg, '/') ? [arg] : [...memo, arg], []);
  const removeExtraSlashes = arg => arg.replace(/(\/)\/+/, '$1');
  const removeWildcards = arg => arg.replace(/[*]{1,2}/, '');
  const resolveRelative = resolveRelativeArgs => {
    return (0, _reduce.default)(resolveRelativeArgs).call(resolveRelativeArgs, (memo, arg) => {
      if (arg === '..') {
        memo = (0, _slice.default)(memo).call(memo, 0, -1);
      } else if (arg !== '.') {
        memo = [...memo, arg];
      }
      return memo;
    }, []);
  };
  const convertToString = arg => (0, _isNil2.default)(arg) ? '' : `${arg}`;
  const resolve = (0, _compose2.default)((0, _add2.default)('/'), (0, _join2.default)('/'), resolveRelative, _unnest2.default, (0, _map4.default)((0, _flowRight2.default)((0, _filter3.default)(isNotEmpty), (0, _split2.default)('/'), removeWildcards, removeExtraSlashes)), preferAbsolute, (0, _map4.default)(convertToString));
  return resolve(args);
}
function _addHandler(type, handler) {
  if ((0, _isFunction2.default)(handler) && _(this).handlers[type] instanceof _set.default) {
    _(this).handlers[type].add(handler);
    _handlers.set(handler, {
      ..._(this).config,
      type
    });
  }
}
class History {
  static on(pathname, query) {
    return new History(pathname, query);
  }
  static off(...handlers) {
    if (handlers.length < 1) {
      handlers = ['*'];
    }
    for (const handler of handlers) {
      if (handler === '*') {
        _handlers.clear();
      } else {
        _handlers.delete(handler);
      }
    }
    return History;
  }
  constructor(pathname, query) {
    (0, _assign.default)(_(this), {
      handlers: {
        enter: new _set.default(),
        leave: new _set.default()
      },
      config: {
        pathname,
        query,
        active: false
      }
    });
  }
  enter(handler) {
    _addHandler.call(this, 'enter', handler);
    return this;
  }
  leave(handler) {
    _addHandler.call(this, 'leave', handler);
    return this;
  }
  off(...types) {
    if (types.length < 1) {
      types = ['*'];
    }
    for (const type of types) {
      if ((0, _isString2.default)(type) && _(this).handlers[type] instanceof _set.default) {
        History.off(..._(this).handlers[type]);
      } else if ((0, _isNil2.default)(type) || type === '*') {
        History.off(...[..._(this).handlers.enter, ..._(this).handlers.leave]);
      } else if ((0, _isFunction2.default)(type)) {
        History.off(type);
      }
    }
    return this;
  }
}
exports.History = History;
function addHistoryListener(pathname, query, enter, leave) {
  if ((0, _isFunction2.default)(query) && arguments.length < 4) {
    leave = enter;
    enter = query;
    query = {};
  }
  if (!(0, _isString2.default)(pathname)) {
    throw new TypeError(`addHistoryListener: pathname must be a string; "${typeof pathname}" found`);
  }
  if (!(0, _isNil2.default)(query) && !(0, _isPlainObject2.default)(query)) {
    throw new TypeError(`addHistoryListener: query must be an Object or null; "${typeof query}" found`);
  }
  return History.on(pathname, query).enter(enter).leave(leave);
}
function removeHistoryListener(...handlers) {
  History.off(...handlers);
}
const _handlers = new _map3.default();
function handlerWrapper(e) {
  (0, _forEach.default)(_handlers).call(_handlers, (config, handler) => {
    let {
      pathname,
      query
    } = config;
    const {
      active,
      type
    } = config;
    if ((0, _isFunction2.default)(pathname)) {
      pathname = pathname();
    }
    if ((0, _isFunction2.default)(query)) {
      query = query();
    }
    let match;
    if ((0, _isString2.default)(pathname)) {
      match = testURL(pathname, query);
    } else if ((0, _isArray.default)(pathname)) {
      var _context4, _context5;
      pathname = (0, _filter2.default)(_context4 = (0, _uniq2.default)((0, _compact2.default)((0, _flattenDeep2.default)(pathname)))).call(_context4, _isString2.default);
      match = (0, _includes.default)(_context5 = (0, _map2.default)(pathname).call(pathname, _pathname => !!testURL(_pathname, query))).call(_context5, true);
    }
    if (match && !active) {
      if ((0, _isFunction2.default)(handler) && type === 'enter') {
        handler(new CustomEvent('history:enter', {
          detail: {
            ...e.detail,
            ...match
          }
        }));
      }
      _handlers.set(handler, {
        ...config,
        active: true
      });
    } else if (!match && active) {
      if ((0, _isFunction2.default)(handler) && type === 'leave') {
        handler(new CustomEvent('history:leave', {
          detail: {
            ...e.detail
          }
        }));
      }
      _handlers.set(handler, {
        ...config,
        active: false
      });
    }
  });
}
if (typeof window !== 'undefined') {
  window.addEventListener('history:load', handlerWrapper);
  window.addEventListener('history:change', handlerWrapper);
}